const Header = ({ children }) => {
  return (
    <header className="md:py-18 relative py-8 lg:py-16 2xl:py-24">
      {children}
    </header>
  )
}

export default Header
